"use client";

import { useQuery, type UseQueryResult } from "@tanstack/react-query";

import { fetchAutomationsUsage } from "../../client/manager/automations";
import type { AutomationsUsage } from "../../models/automations-usage";
import { automationsKeys } from "./automationsQueryKeys";

/** Credits the Automations pool spent since `since` (ISO); idle until it is set. */
export function useAutomationsUsage(
  comedianId: string,
  since: string | null | undefined
): UseQueryResult<AutomationsUsage> {
  return useQuery({
    queryKey: automationsKeys.usage(comedianId, since),
    queryFn: () => fetchAutomationsUsage(comedianId, since as string),
    enabled: !!comedianId && !!since,
    staleTime: 60 * 1000,
    retry: false,
  });
}
